









import Vue from 'vue'
import { ProductSearchTag } from '@/product/types'
import { FACET_QUERY_PREFIX } from '@/search/const'

export default Vue.extend({
  props: {
    searchTag: {
      type: Object as () => ProductSearchTag,
      required: true
    }
  },
  computed: {
    linkUrl(): string {
      return this.searchTag.secondConditionType === 'brand' ?
        `${this.searchTag.categoryUrl}?${this.searchSecondQuery}` :
        `/search?category=${this.searchTag.firstConditionValue}&${this.searchSecondQuery}`
    },
    searchSecondQuery(): string {
      switch (this.searchTag.secondConditionType) {
        case 'industry' :
          return `industries=${this.searchTag.secondConditionValue}`
        case 'printing_method':
          return `printing=${this.searchTag.secondConditionValue}`
        case 'edit_pattern':
          return `editPatterns=${this.searchTag.secondConditionValue}`
        default:
          return `${FACET_QUERY_PREFIX}${this.searchTag.secondConditionType}=${this.searchTag.secondConditionValue}`
      }
    }
  }
})
